import { Trans } from '@lingui/react/macro';

import { FieldError, type FieldErrorProps } from '@/components/Form/fields';

import RuleBuilderOperatorSelect from './RuleBuilderOperatorSelect';
import RuleBuilderText from './RuleBuilderText';
import type { AttributeOperatorType, RuleEntityAttributeType } from './types';

type Props = {
  attribute: RuleEntityAttributeType;
  value?: AttributeOperatorType;
  onChange?: (value: AttributeOperatorType | null) => void;
  onBlur?: () => void;
  errors?: FieldErrorProps['errors'];
  disabled?: boolean;
  className?: string;
};

const RuleBuilderOperator = ({
  attribute,
  value,
  onChange,
  onBlur,
  errors,
  disabled = false,
  className,
}: Props) => {
  if (attribute.display === 'picker') {
    return (
      <RuleBuilderText variant="body1">
        <Trans>is</Trans>
      </RuleBuilderText>
    );
  }

  return (
    <div className={className}>
      <RuleBuilderOperatorSelect
        attribute={attribute}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
      />
      <FieldError errors={errors} />
    </div>
  );
};

export default RuleBuilderOperator;
